
import { Pipe, PipeTransform } from '@angular/core';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaxationTypeEnumNameI18n } from '@zaoblako/shared/modules/catalog/i18n/taxation-type-enum-name.i18n';

@Pipe({
  standalone: true,
  name: 'taxationTypeName'
})
export class TaxationTypeNamePipe implements PipeTransform {
  public transform(value: TaxationTypeEnum): string {
    return TaxationTypeEnumNameI18n[I18nLocalesEnum.RU_RU][value];
  }
}
